export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "「最新爆料」栏目主要做什么？",
    a: "本栏目以人物档案的方式，追踪每一桩热点爆料背后的新主角、新面孔、新涉事者与新当事人。我们把人物角色、关联脉络与最新动态梳理成清晰条目，帮助读者在信息纷杂时快速把握谁与谁有关、事件推进到哪一步。",
  },
  {
    q: "为什么文中使用「阿舟」「张某」等化名？",
    a: "为保护尚未定论的信源与当事人，编辑部在报道中对部分对象采用化名或角色口径呈现。化名不改变事实梳理，也不意味着对身份的猜测，仅是为了在核实结论前避免给具体个人造成不必要的影响。",
  },
  {
    q: "「涉事主角」与「关联当事人」有什么区别？",
    a: "「涉事主角」指在可验证材料中被直接指向的主要对象；「关联当事人」则指与被点名者存在业务、往来或在场交集、但角色性质尚待进一步核实的一方。我们对后者只作关联标注，不作责任判断，随材料补充可动态调整定性。",
  },
  {
    q: "会不会把未经证实的内容当成事实发布？",
    a: "不会。每条信息在写入档案前都要求可验证的旁证，或经关联素材交叉印证。对于无法核实的表态，我们统一注明「未经独立核实」，并提示读者将其作为进展参考而非定论，避免以孤证支撑结论。",
  },
  {
    q: "事件有进展时，你们会如何更新？",
    a: "我们会在「最新动态」与各人物档案内同步滚动更新：新增材料、回应口径变化、关系图谱调整都会及时标注日期与状态（如证据核实中、待交叉核实、已发声明），读者可按时间查看完整演变过程。",
  },
];